import { createRouter, createMemoryHistory } from '@tanstack/react-router'
import { Capacitor } from '@capacitor/core'
import { Route as rootRoute } from '../__root'
import { Route as appLayoutRoute } from '../layouts/app.layout.route'
import { Route as homeRoute } from '@/pages/home/page.home.route'
import { Route as petRoute } from '@/pages/pet/page.pet.route'
import { Route as rentersRoute } from '@/pages/renters/page.renters.route'
import { Route as claimsRoute } from '@/pages/claims/page.claims.route'
import { Route as perksRoute } from '@/pages/perks/page.perks.route'
import { Route as goalsRoute } from '@/pages/goals/page.goals.route'
import { Route as documentsRoute } from '@/pages/documents/page.documents.route'
import { Route as contactRoute } from '@/pages/contact/page.contact.route'
import { Route as billingRoute } from '@/pages/billing/page.billing.route'
import { Route as loginRoute } from '@/pages/auth/login/page.login.route'
import { Route as verifyCodeRoute } from '@/pages/auth/verify-code/page.verify-code.route'
import { Route as paymentRoute } from '@/pages/payment/page.payment.route'
import { Route as paymentInUpdateRoute } from '@/pages/payment/in/page.payment-in-update.route'
import { Route as paymentOutUpdateRoute } from '@/pages/payment/out/page.payment-out-update.route'
import { Route as designSystemRoute } from '@/pages/design-system/page.design-system.route'
import { Route as onboardingRentersFormRoute } from '@/pages/onboarding/renters/form/page.onboarding-renters-form.route'
import { Route as onboardingPet } from '@/pages/onboarding/pet/page.onboarding.pet.route'
import { Route as onboardingRentersRoute } from '@/pages/onboarding/renters/page.onboarding-renters.route'
import { Route as onboardingPetForm } from '@/pages/onboarding/pet/form/page.onboarding.pet-form.route'
import { Route as televetRoute } from '@/pages/televet/page.televet.route'
import { Route as claimsDetailRoute } from '@/pages/claims/detail/page.claims-detail.route'
import { Route as claimsEditRoute } from '@/pages/claims/edit/page.claims-edit.route'
import { Route as claimsPetRoute } from '@/pages/claims/pet/page.claims.pet.route'
import { Route as claimsRentersRoute } from '@/pages/claims/renters/page.claims.renters.route'
import { QueryProvider } from './query-provider'

const routeTree = rootRoute.addChildren([
  appLayoutRoute.addChildren([
    homeRoute,
    petRoute,
    rentersRoute,
    claimsRoute,
    perksRoute,
    goalsRoute,
    documentsRoute,
    contactRoute,
    billingRoute,
  ]),
  loginRoute,
  verifyCodeRoute,
  paymentRoute,
  paymentInUpdateRoute,
  paymentOutUpdateRoute,
  designSystemRoute,
  onboardingRentersFormRoute,
  onboardingPet,
  onboardingRentersRoute,
  onboardingPetForm,
  televetRoute,
  claimsDetailRoute,
  claimsEditRoute,
  claimsPetRoute,
  claimsRentersRoute,
])

export const router = createRouter({
  history: Capacitor.isNativePlatform() ? createMemoryHistory() : undefined,
  routeTree,
  Wrap({ children }: { children: React.ReactNode }) {
    return <QueryProvider>{children}</QueryProvider>
  },
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
